/* ==========================================================================
   MODAL
   ========================================================================== */

// open modal by id
function openModal(id: string) {
  window.dispatchEvent(new Event("resize"));
  const modal = document.getElementById(id);
  if (modal) {
    modal.classList.add("open");
    document.body.classList.add("js-modal-open");

    // Check if modal is within the header
    const header = document.getElementById("header");
    if (!header?.querySelector("#" + id)) {
      document.body.classList.add("js-modal-open--hide-header");
    }
  }
}

// close currently open modal
function closeModal() {
  window.dispatchEvent(new Event("resize"));
  for (const modal of document.querySelectorAll<HTMLDivElement>(
    ".js-modal.open"
  )) {
    modal.classList.remove("open");
  }
  document.body.classList.remove("js-modal-open");
  document.body.classList.remove("js-modal-open--hide-header");
}

window.addEventListener("load", function () {
  // open modal on modal button with id
  for (const modalButton of document.querySelectorAll<HTMLButtonElement>(
    ".js-modal-button"
  )) {
    modalButton.addEventListener("click", () => {
      const id = modalButton.dataset.modalId;
      if (id) {
        openModal(id);
      }
    });
  }

  // close modals on close button
  for (const closeButton of document.querySelectorAll<HTMLButtonElement>(
    ".js-modal__close"
  )) {
    closeButton.addEventListener("click", () => {
      closeModal();
    });
  }

  // close modals on background click
  for (const modal of document.querySelectorAll<HTMLDivElement>(".js-modal")) {
    modal.addEventListener("click", (event) => {
      if (
        event.target.classList.contains("open") &&
        event.target.classList.contains("js-modal")
      ) {
        closeModal();
      }
    });
  }
});
